module.exports = __webpack_public_path__ + "static/media/global-network.d0bbbc46.svg";